import { useState } from "react"

type Status = "idle" | "loading" | "success" | "error"

export function NewsletterForm() {
  const [email, setEmail] = useState("")
  const [status, setStatus] = useState<Status>("idle")

  async function submit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault()
    if (status === "loading") return
    setStatus("loading")
    try {
      const res = await fetch("/api/public/subscribe", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ email }),
      })
      if (!res.ok) throw new Error(`subscribe failed: ${res.status}`)
      setStatus("success")
    } catch {
      setStatus("error")
    }
  }

  if (status === "success") {
    return (
      <div className="newsletter-success">
        <span className="newsletter-success__mark" aria-hidden>✓</span>
        <div>
          <p className="font-semibold text-white">You&apos;re on the list.</p>
          <p className="mt-1 text-sm text-white/70">Check your inbox for a welcome email.</p>
        </div>
      </div>
    )
  }

  return (
    <div>
      <form onSubmit={submit} className="flex flex-col gap-2.5 lg:h-[46px] lg:flex-row">
        <input
          type="email"
          required
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          placeholder="Email"
          aria-label="Email address"
          disabled={status === "loading"}
          className="h-11 w-full rounded-full bg-white px-4 text-base text-ink outline-none transition-colors placeholder:text-ink/40 focus:outline-none focus:ring-0 disabled:opacity-60 lg:h-[46px] lg:w-[302px] lg:flex-none"
        />
        <button
          type="submit"
          disabled={status === "loading"}
          className="h-11 rounded-full bg-gold-500 px-7 text-sm font-bold uppercase tracking-normal text-ink transition-colors hover:bg-gold-400 disabled:opacity-60 lg:h-[46px] lg:w-[144px] lg:px-0"
        >
          {status === "loading" ? "Subscribing..." : "SUBSCRIBE ME"}
        </button>
      </form>
      {status === "error" && (
        <p className="mt-3 text-sm text-gold-400">Something went wrong — please try again.</p>
      )}
    </div>
  )
}
